import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/gtag';
import { hasConsent } from '@/lib/consent';

/** Sends a GA4 page_view on every route change. Must be inside <BrowserRouter>. */
export default function GAPageTracker() {
  const location = useLocation();

  useEffect(() => {
    // SAB-431: skip when analytics consent not granted. trackPageView would
    // also short-circuit (window.gtag is undefined when GA wasn't initialized
    // by AnalyticsGate) but bailing here is explicit and saves the function
    // call cost.
    if (!hasConsent('analytics')) return;
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
